import { useSendToPanel } from "providers";
import { useTranslations } from "providers";

import { SendToFormRow } from "./SendToFormRow";

export const SendToForm: React.FC = () => {
  const i18n = useTranslations();
  const { results, getId } = useSendToPanel();

  return (
    <table className="table sbb-table-bs">
      <thead>
        <tr>
          <th />
          <th>{i18n.SendtoPanel_Committee}</th>
          <th />
          <th>{i18n.SendtoPanel_Meeting}</th>
        </tr>
      </thead>
      <tbody>
        {results.map((item) => {
          var key = `sendto-${getId(item)}`;
          return <SendToFormRow key={key} item={item} />;
        })}
      </tbody>
    </table>
  );
};
